import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getProjectExpectedResult = (projectVersionId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/expected-result`
  return doGet(url)
}

export const saveResult = (projectVersionId, schema) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/expected-result/result`
  return doPost(url, schema)
}

export const updateResult = (projectVersionId, schema) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/expected-result/result/${schema.id}`
  return doPut(url, schema)
}

export const deleteResult = (projectVersionId, resultId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/expected-result/result/${resultId}`
  return doDelete(url)
}

export const saveBenefit = (projectVersionId, schema) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/expected-result/benefit`
  return doPost(url, schema)
}

export const updateBenefit = (projectVersionId, schema) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/expected-result/benefit/${schema.id}`
  return doPut(url, schema)
}

export const deleteBenefit = (projectVersionId, resultId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/expected-result/benefit/${resultId}`
  return doDelete(url)
}

// -------------------------------------------------------------------------

export const saveProjectExpectedResult = (id, schema) => {
  const url = `${API_ROOT}/proposal/${id}/expected/result`
  return doPost(url, schema)
}

export const updateProjectExpectedResult = (id, schema) => {
  const url = `${API_ROOT}/proposal/${id}/expected/result/${schema.id}`
  return doPut(url, schema)
}

export const deleteProjectExpectedResult = (id, resultId) => {
  const url = `${API_ROOT}/proposal/${id}/expected/result/${resultId}`
  return doDelete(url)
}
